export default function Header() {
    return (
      <div className="Header">
        <h2> Employee Directory </h2>
      </div>
    );
  }
  